import { ReportState, FileInfo, FileBasedReport, ReportData } from '../../types/report.types';
import { CLEAR_REPORT_MESSAGES } from '../actions/reportActions';

export enum ActionTypes {
    SET_LOADING = 'SET_LOADING',
    SET_ERROR = 'SET_ERROR',
    SET_REPORT_DATA = 'SET_REPORT_DATA',
    SET_FILES_LIST = 'SET_FILES_LIST',
    SELECT_FILE = 'SELECT_FILE',
    SET_CURRENT_REPORT = 'SET_CURRENT_REPORT',
    ADD_REPORT = 'ADD_REPORT',
    SET_PAGINATION = 'SET_PAGINATION',
    SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS'
}

interface SetLoadingAction {
    type: ActionTypes.SET_LOADING;
    payload: boolean;
}

interface SetErrorAction {
    type: ActionTypes.SET_ERROR;
    payload: string | null;
}

interface SetReportDataAction {
    type: ActionTypes.SET_REPORT_DATA;
    payload: FileBasedReport | null;
}

interface SetFilesListAction {
    type: ActionTypes.SET_FILES_LIST;
    payload: {
        files: FileInfo[];
        metadata: {
            total_records: number;
            page: number;
            per_page: number;
            total_pages: number;
            generated_at: string;
        };
    };
}

interface SelectFileAction {
    type: ActionTypes.SELECT_FILE;
    payload: FileInfo | null;
}

interface SetCurrentReportAction {
    type: ActionTypes.SET_CURRENT_REPORT;
    payload: ReportData | null;
}

interface AddReportAction {
    type: ActionTypes.ADD_REPORT;
    payload: ReportData;
}

interface SetPaginationAction {
    type: ActionTypes.SET_PAGINATION;
    payload: {
        page: number;
        per_page: number;
        total_items: number;
        total_pages: number;
    };
}

interface SetSearchResultsAction {
    type: ActionTypes.SET_SEARCH_RESULTS;
    payload: ReportData[];
}

interface ClearReportMessagesAction {
    type: typeof CLEAR_REPORT_MESSAGES;
}

type ReportAction = 
    | SetLoadingAction 
    | SetErrorAction 
    | SetReportDataAction 
    | SetFilesListAction 
    | SelectFileAction
    | SetCurrentReportAction
    | AddReportAction
    | SetPaginationAction
    | SetSearchResultsAction
    | ClearReportMessagesAction;

const initialState: ReportState = {
    data: null,
    loading: false,
    error: null,
    files: {
        list: [],
        metadata: {
            total_records: 0,
            page: 1,
            per_page: 10,
            total_pages: 0
        }
    },
    selectedFile: null,
    reports: [],
    currentReport: null,
    searchResults: [],
    pagination: {
        page: 1,
        per_page: 10,
        total_items: 0,
        total_pages: 0
    }
};

const reportReducer = (state = initialState, action: ReportAction): ReportState => {
    switch (action.type) {
        case ActionTypes.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case ActionTypes.SET_ERROR:
            return {
                ...state,
                error: action.payload
            };
        case ActionTypes.SET_REPORT_DATA:
            return {
                ...state,
                data: action.payload
            };
        case ActionTypes.SET_FILES_LIST:
            return {
                ...state,
                files: {
                    list: action.payload.files,
                    metadata: action.payload.metadata
                }
            };
        case ActionTypes.SELECT_FILE:
            return {
                ...state,
                selectedFile: action.payload
            };
        case ActionTypes.SET_CURRENT_REPORT:
            return {
                ...state,
                currentReport: action.payload
            };
        case ActionTypes.ADD_REPORT:
            return {
                ...state,
                reports: [...state.reports, action.payload]
            };
        case ActionTypes.SET_PAGINATION:
            return {
                ...state,
                pagination: action.payload
            };
        case ActionTypes.SET_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: action.payload
            };
        case CLEAR_REPORT_MESSAGES:
            return {
                ...state,
                error: null
            };
        default:
            return state;
    }
};

export default reportReducer; 